import React from 'react';
import { createContext, useEffect, useState } from 'react';
import jwt_decode from 'jwt-decode';
import { useLocation, useNavigate } from 'react-router-dom';
import { AUTH_CONFIG, SERVICE_TICKET } from '../services/Api';

export const AuthContext = React.createContext();

export const AuthStorage = ({ children }) => {
  const [user, setUser] = React.useState(null);
  const [login, setLogin] = React.useState();
  const navigate = useNavigate();
  const location = useLocation();
  const callbackUri = `${window.location.origin}/auth`;
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    if (!AUTH_CONFIG.autoLogon) {
      setLoading(false);
      return;
    }

    const token = window.localStorage.getItem('token');
    if (token) {
      try {
        const jwtDecoded = jwt_decode(token);
        setUser(jwtDecoded);
        setLogin(true);
      } catch (e) {
        console.error('Token inválido', e);
        setLogin(false);
      }
    } else {
      setLogin(false);
    }
    setLoading(false);
  }, []);
  function loginUser() {
    localStorage.setItem('pathAfterLogin', '/principal');
    //    const origem = window.localStorage.getItem('origem');
    //    if(!origem){
    localStorage.setItem('origem', 'meuCorreios');
    //    }
    localStorage.removeItem('token');
    window.location.href = `${AUTH_CONFIG.loginUrl}?service=${callbackUri}`;
  }

  /*function temPermissao(funcionalidades) {
    return funcionalidades?.some((f) => user?.authorities?.includes(f));
  } 

  const perfil = () => {
    navigate('/Perfil');
  };*/

  const logout = () => {
    localStorage.setItem('pathAfterLogin', '/');
    localStorage.removeItem('token');
    setUser(null);
    setLogin(false);
    navigate('/');
  };

  const newSession = () => {
    localStorage.removeItem('token');
    setUser(null);
    setLogin(false);
    window.location.href = `${AUTH_CONFIG.logoutUrl}?service=${AUTH_CONFIG.uriPublica}`;
  };

  const resetSenha = () => {
    localStorage.removeItem('token');
    setUser(null);
    setLogin(false);
    navigate("/esqueciMinhaSenhaPJ", { state: { resetsnh: true } });
  };

  const buscaToken = React.useCallback(
    async (serviceTicket) => {
      const stRequest = SERVICE_TICKET({
        service: callbackUri,
        ticket: serviceTicket,
      });
      const response = await fetch(stRequest.url, stRequest.options);
      if (!response.ok) {
        setLogin(false);
        return false;
      }
      const json = await response.json();
      //setUser(json?.serviceResponse?.authenticationSuccess?.user);
      //setLogin(true);
      //return true;
      const jwt = json?.serviceResponse?.authenticationSuccess?.attributes?.jwt;
      if (!jwt) {
        setLogin(false);
        return false;
      }

      localStorage.setItem('token', jwt[0]);
      const jwtDecoded = jwt_decode(jwt[0]);
      setUser(jwtDecoded);
      setLogin(true);
      return true;
    },
    [callbackUri],
  );

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        loginUser,
        logout,
        newSession,
        resetSenha,
        buscaToken,
        loading,
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};
